import getHelper from '../../../../services/getHelper';

export default getHelper('/teams/:id');
